import { create, get } from "@github/webauthn-json";

import { existingHeaders } from "./utils";
import { formatCredentials } from "utils/webAuthn";
import { missionId } from "utils/urls";
import { CUSTOMER_ID, DEVICE_ID } from "constants/webAuthn";

const REGISTER_START_ENDPOINT = "/customer/webauthn/registration/start";
const REGISTER_FINISH_ENDPOINT = "/customer/webauthn/registration/finish";
const DELETE_DEVICE_ENDPOINT =
  "/customer/webauthn/{customerId}/devices/{deviceId}";

const ASSERTION_START_ENDPOINT = "/webauthn/assertion/start";
export const ASSERTION_FINISH_ENDPOINT = `/${missionId}/webauthn/assertion/finish`;

export const webAuthnService = {
  registerDevice,
  logInWithDevice,
  deleteDevice,
};

const requestOptions = {
  credentials: "same-origin",
  headers: existingHeaders,
  method: "POST",
};

async function deleteDevice() {
  const customerId = localStorage.getItem(CUSTOMER_ID);
  const deviceId = localStorage.getItem(DEVICE_ID);
  if (customerId && deviceId) {
    const url = DELETE_DEVICE_ENDPOINT.replace(
      "{customerId}",
      customerId
    ).replace("{deviceId}", deviceId);
    return await fetch(url, {
      ...requestOptions,
      method: "DELETE",
    });
  } else {
    return Promise.resolve();
  }
}

async function registerDevice() {
  const registerStart = await fetch(REGISTER_START_ENDPOINT, {
    ...requestOptions,
  });

  const registrationOptions = await registerStart.json();
  const { publicKeyCredentialCreationOptions } = registrationOptions;
  publicKeyCredentialCreationOptions.excludeCredentials = [];
  const credentials = await create({
    publicKey: publicKeyCredentialCreationOptions,
  });

  const formattedCredentials = formatCredentials(credentials);

  localStorage.setItem(DEVICE_ID, formattedCredentials.id);

  const registerFinish = {
    registrationId: registrationOptions.registrationId,
    deviceName: navigator.userAgent,
    credential: {
      ...formattedCredentials,
      clientExtensionResults: {},
    },
  };

  return fetch(REGISTER_FINISH_ENDPOINT, {
    ...requestOptions,
    body: JSON.stringify(registerFinish),
  });
}

async function logInWithDevice(customerId) {
  const response = await fetch(ASSERTION_START_ENDPOINT, {
    ...requestOptions,
    body: JSON.stringify({ customer_id: customerId }),
  });

  const responseBody = await response.json();
  const customerAssertionId = responseBody.customerAssertionId;
  const publicKeyCred = await get({
    publicKey: responseBody.publicKeyCredentialRequestOptions,
  });

  return {
    publicKeyCred: publicKeyCred,
    customerAssertionId: customerAssertionId,
  };
}
